var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-cursor-pointer tw-p-3 tw-rounded-full hover:tw-bg-bg-2 tw-transition-all tw-ease-in-out",class:{
    'tw-opacity-40 !tw-cursor-default': _vm.disabled,
    'hover:tw-bg-purple-100': _vm.showBackgroundHover,
  },on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }